import { render, staticRenderFns } from "./auxiliaryPopup.vue?vue&type=template&id=b5f6a050&scoped=true"
import script from "./auxiliaryPopup.vue?vue&type=script&lang=js"
export * from "./auxiliaryPopup.vue?vue&type=script&lang=js"
import style0 from "./auxiliaryPopup.vue?vue&type=style&index=0&id=b5f6a050&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f6a050",
  null
  
)

export default component.exports